import * as THREE from 'three';

export enum NodeType {
  // Global Params & Logic
  PARAMETER = 'PARAMETER', 
  EXPRESSION = 'EXPRESSION', 
  CUSTOM = 'CUSTOM', 

  // 2D Primitives
  LINE = 'LINE',
  RECTANGLE = 'RECTANGLE',
  CIRCLE = 'CIRCLE',
  ARC = 'ARC',
  ELLIPSE = 'ELLIPSE',
  POLYGON = 'POLYGON',
  STAR = 'STAR', 

  // 3D Primitives
  BOX = 'BOX', // Restored Box
  SPHERE = 'SPHERE',
  ELLIPSOID = 'ELLIPSOID',
  CYLINDER = 'CYLINDER',
  CONE = 'CONE',
  TRUNCATED_CONE = 'TRUNCATED_CONE',
  TORUS = 'TORUS',
  CAPSULE = 'CAPSULE', 
  // Removed Polyhedrons

  // Features / Operations
  GROUP = 'GROUP', 
  FILLET = 'FILLET', // Generic Fillet
  // Removed MAKE_FACE
  EXTRUDE = 'EXTRUDE',
  REVOLVE = 'REVOLVE',
  SWEEP = 'SWEEP',
  LOFT = 'LOFT',
  BOOLEAN_OP = 'BOOLEAN_OP', 
  BOUNDING_BOX = 'BOUNDING_BOX',
  SURFACE_AREA = 'SURFACE_AREA',
  VOLUME = 'VOLUME',
  CENTROID = 'CENTROID',
  NUMBER_RANGE = 'NUMBER_RANGE',
  RANGE_BY_COUNT = 'RANGE_BY_COUNT',
  LIST_CREATE = 'LIST_CREATE',
  LIST_LENGTH = 'LIST_LENGTH',
  LIST_GET_ITEM = 'LIST_GET_ITEM',
  LIST_FLATTEN = 'LIST_FLATTEN',
  LIST_FIRST = 'LIST_FIRST',
  LIST_LAST = 'LIST_LAST',
  LIST_JOIN = 'LIST_JOIN',
  LIST_SLICE = 'LIST_SLICE',
  LIST_REVERSE = 'LIST_REVERSE',
  LIST_UNIQUE = 'LIST_UNIQUE',
  LIST_REPEAT = 'LIST_REPEAT',
  VECTOR_CREATE = 'VECTOR_CREATE',
  VECTOR_ADD = 'VECTOR_ADD',
  VECTOR_SUBTRACT = 'VECTOR_SUBTRACT',
  VECTOR_SCALE = 'VECTOR_SCALE',
  VECTOR_LENGTH = 'VECTOR_LENGTH',
  VECTOR_NORMALIZE = 'VECTOR_NORMALIZE',
  VECTOR_DOT = 'VECTOR_DOT',
  VECTOR_CROSS = 'VECTOR_CROSS',
  VECTOR_DISTANCE = 'VECTOR_DISTANCE',
  VECTOR_ANGLE = 'VECTOR_ANGLE',
  VECTOR_LERP = 'VECTOR_LERP',
  MATH_ADD = 'MATH_ADD',
  MATH_SUBTRACT = 'MATH_SUBTRACT',
  MATH_MULTIPLY = 'MATH_MULTIPLY',
  MATH_DIVIDE = 'MATH_DIVIDE',
  MATH_POWER = 'MATH_POWER',
  MATH_ABS = 'MATH_ABS',
  MATH_CLAMP = 'MATH_CLAMP',
  MATH_REMAP = 'MATH_REMAP',
  
  // Transformation
  TRANSLATION = 'TRANSLATION',
  ROTATION = 'ROTATION',
  SCALE = 'SCALE',
  MIRROR = 'MIRROR', 
  ARRAY_LINEAR = 'ARRAY_LINEAR', 
  ARRAY_GRID = 'ARRAY_GRID', 
  ARRAY_POLAR = 'ARRAY_POLAR'
}

export type SocketType = 'number' | 'geometry' | 'vector' | 'boolean' | 'shape2d' | 'curve' | 'any' | 'color';

export interface NodeSocket {
  id: string;
  name: string;
  type: SocketType;
  value?: any; 
}

export interface NodeData {
  id: string;
  type: NodeType;
  position: { x: number; y: number };
  inputs: NodeSocket[];
  outputs: NodeSocket[];
  label: string;
  params: Record<string, any>; 
}

export interface Connection {
  id: string;
  sourceNodeId: string;
  sourceSocketId: string;
  targetNodeId: string;
  targetSocketId: string;
}

export interface ConnectionDraft {
  sourceNodeId: string;
  sourceSocketId: string;
  sourceType: SocketType;
  isInput: boolean;
  currentPos: { x: number, y: number };
  snappedNodeId?: string;
  snappedSocketId?: string;
}

export interface LogEntry {
  id: string;
  timestamp: Date;
  message: string;
  type: 'info' | 'success' | 'error' | 'warning';
}

export interface GraphState {
  nodes: NodeData[];
  connections: Connection[];
  selectedNodeIds: string[];
  pan: { x: number; y: number };
  zoom: number;
  logs: LogEntry[];
  connectionDraft: ConnectionDraft | null;
  language: 'zh' | 'en';
}
